import { render, staticRenderFns } from "./TableBody.vue?vue&type=template&id=07b8ae5e&"
import script from "./TableBody.vue?vue&type=script&lang=js&"
export * from "./TableBody.vue?vue&type=script&lang=js&"
import style0 from "./TableBody.vue?vue&type=style&index=0&id=07b8ae5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports